var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.8 30",
    style: {
      enableBackground: "new 0 0 58.8 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.7,14.1c-0.5,0.9-1,1.6-1.6,2.3c-0.8,0.8-1.6,1.3-2.3,1.3c-0.8,0-1.4-0.5-1.9-1.7c-0.3,0.5-0.5,0.9-0.7,1.1 c-0.4,0.4-0.7,0.5-1.1,0.5c-0.3,0-0.5-0.1-0.8-0.2L8,16.5c0.3,0.2,0.5,0.3,0.5,0.3c0.4,0,0.7-0.4,1.2-1.2c-0.2-0.5-0.4-0.9-0.5-1.1 c-0.3-0.3-0.6-0.5-1.1-0.5L8.5,13h0.1h0.3c0.5,0,1.1,0.5,1.5,1.5c0.5-1.1,1.1-1.5,1.6-1.5c0.2,0,0.5,0.1,0.7,0.3l-0.5,0.8 c-0.3-0.3-0.5-0.4-0.6-0.4c-0.2,0-0.5,0.4-0.9,1.1c0.4,0.7,0.5,1.3,0.7,1.4c0.4,0.6,0.8,0.9,1.3,0.9c0.5,0,1.2-0.4,1.8-1.2 C14.9,15.4,15.3,14.8,15.7,14.1L15.7,14.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.8,
    transform: "matrix(0.4722 -0.8815 0.8815 0.4722 0.5161 15.8448)",
    width: 0.9,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: 21,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -8.883 9.7168)",
    width: 28.6,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 11,
    width: 3.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M0.9,29.1h28.2V0.9H0.9V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6,25.9H4.1V3.8h22.5V25.9z M4.9,25h20.9V4.6H4.9V25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9,
    y: -6.8,
    transform: "matrix(0.4722 -0.8815 0.8815 0.4722 15.7322 41.2564)",
    width: 0.9,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 21,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -5.0289 24.1168)",
    width: 28.6,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,30h-30V0h30V30z M29.7,29.1h28.2V0.9H29.7V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,25.9H32.9V3.8h22.5V25.9z M33.7,25h20.9V4.6H33.7V25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk20);
export default __webpack_public_path__ + "static/media/ak_2_0.397bbe6ed9d8ed0cc6a23a30af987600.svg";
export { ForwardRef as ReactComponent };